import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import Portal from "@/pages/Portal";
import QuoteDetail from "@/pages/QuoteDetail";
import Admin from "@/pages/Admin";
import Rewards from "@/pages/Rewards";
import Campaigns from "@/pages/Campaigns";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/cotizar" element={<Wizard />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/cotizacion/:quoteId" element={<QuoteDetail />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/recompensas" element={<Rewards />} />
      <Route path="/campanas" element={<Campaigns />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset" element={<ResetPassword />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
